import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//开始时注释下方样式代码，否则热更新响应缓慢
import './theme.scss'
ElementUI.Select.computed.readonly = function(){
  return !this.filterable;
}
Vue.use(ElementUI)


// WEBPACK FOOTER //
// ./src/element/index.js